import React from 'react';
import { Box, Card, CardContent, Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { Air as AirIcon, CloudQueue as CloudQueueIcon, Compress as CompressIcon, Water as WaterIcon, } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { cardinalFromDegree, CardinalSubset } from 'cardinal-direction';
import { useQuery } from 'react-query';
import convert from 'convert-units';
import API from '@wheeebo/polaris-api';
import { CircleLoader, LoadError } from '../loader';
import { useMap } from '../map';
function Section({ children }) {
    const theme = useTheme();
    return (React.createElement(Stack, { gap: 1 / 4, sx: {
            flex: 1,
            borderLeftWidth: 1,
            borderLeftColor: theme.palette.warning.light,
            borderLeftStyle: 'solid',
            px: 1,
        } }, children));
}
function SectionItem({ icon, title, content }) {
    return (React.createElement(Box, null,
        React.createElement(Stack, { gap: 1 / 2, direction: "row", sx: { alignItems: 'center' } },
            icon,
            React.createElement(Typography, { variant: "caption" }, title)),
        React.createElement(Typography, { variant: "body1", sx: { pl: 1 / 2, lineHeight: 'normal' } }, content)));
}
function WeatherCard() {
    const { center } = useMap();
    const { data, isError, isLoading } = useQuery(center ? API.Weathers.getKey(center.lat, center.lng) : '', () => center ? API.Weathers.get(center.lat, center.lng) : undefined);
    const [temperature, setTemperature] = React.useState();
    const [unit, setUnit] = React.useState('C');
    const handleChange = (_, newUnit) => setUnit(newUnit);
    React.useEffect(() => {
        if (!data?.temperature) {
            return;
        }
        if (unit === 'C') {
            setTemperature(data?.temperature);
        }
        else {
            setTemperature(convert(data?.temperature).from('C').to('F'));
        }
    }, [data?.temperature, unit]);
    return (React.createElement(Card, null,
        React.createElement(CardContent, { sx: { py: '8px !important' } },
            isLoading ? React.createElement(CircleLoader, null) : null,
            isError ? React.createElement(LoadError, null) : null,
            data ? (React.createElement(React.Fragment, null,
                React.createElement(Stack, { gap: 1, direction: "row", sx: { alignItems: 'center' } },
                    React.createElement("img", { src: `https://openweathermap.org/img/wn/${data.icon}.png`, width: "42px", height: "42px" }),
                    React.createElement(Typography, { sx: { fontSize: '1.75rem' } }, temperature?.toFixed(2)),
                    React.createElement(Stack, null,
                        React.createElement(ToggleButtonGroup, { size: "small", value: unit, exclusive: true, onChange: handleChange, "aria-label": "Platform" },
                            React.createElement(ToggleButton, { value: "C", sx: { width: 24, height: 24 } }, `\u2103`),
                            React.createElement(ToggleButton, { value: "F", sx: { width: 24, height: 24 } }, `\u2109`)),
                        React.createElement(Typography, { variant: "body2" }, data.location))),
                React.createElement(Stack, { direction: "row", sx: { display: 'flex' } },
                    React.createElement(Section, null,
                        React.createElement(SectionItem, { icon: React.createElement(AirIcon, { color: "action", sx: { fontSize: '1rem' } }), title: "Wind", content: `${data.windSpeed} m/s ${cardinalFromDegree(data.windDegree, CardinalSubset.Intercardinal)}` }),
                        React.createElement(SectionItem, { icon: React.createElement(WaterIcon, { color: "action", sx: { fontSize: '1rem' } }), title: "Humidity", content: `${data.humidity} %` })),
                    React.createElement(Section, null,
                        React.createElement(SectionItem, { icon: React.createElement(CompressIcon, { color: "action", sx: { fontSize: '1rem' } }), title: "Pressure", content: `${data.pressure} hPa` }),
                        React.createElement(SectionItem, { icon: React.createElement(CloudQueueIcon, { color: "action", sx: { fontSize: '1rem' } }), title: "Clouds", content: `${data.clouds} %` }))))) : null)));
}
export default React.memo(WeatherCard);
